"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCheckCouponExpiryRequest = instanceOfCheckCouponExpiryRequest;
exports.CheckCouponExpiryRequestFromJSON = CheckCouponExpiryRequestFromJSON;
exports.CheckCouponExpiryRequestFromJSONTyped = CheckCouponExpiryRequestFromJSONTyped;
exports.CheckCouponExpiryRequestToJSON = CheckCouponExpiryRequestToJSON;
exports.CheckCouponExpiryRequestToJSONTyped = CheckCouponExpiryRequestToJSONTyped;
/**
 * Check if a given object implements the CheckCouponExpiryRequest interface.
 */
function instanceOfCheckCouponExpiryRequest(value) {
    return true;
}
function CheckCouponExpiryRequestFromJSON(json) {
    return CheckCouponExpiryRequestFromJSONTyped(json, false);
}
function CheckCouponExpiryRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'couponIds': json['couponIds'] == null ? undefined : json['couponIds'],
    };
}
function CheckCouponExpiryRequestToJSON(json) {
    return CheckCouponExpiryRequestToJSONTyped(json, false);
}
function CheckCouponExpiryRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'couponIds': value['couponIds'],
    };
}
